import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as Ps from 'perfect-scrollbar';

import defined from '~app/core/defined';

class PerfectScrollbarContainer extends Component {

  constructor(props) {
    super(props);

    // Bind this function only once so that add/removeEventListener are
    // dealing with the same function.
    this._windowResize = ::this.windowResize;
  }

  set scrollTop(top) {
    if (defined(this.scrollContainer)) {
      this.scrollContainer.scrollTop = top;
    }
  }

  set scrollLeft(left) {
    if (defined(this.scrollContainer)) {
      this.scrollContainer.scrollLeft = left;
    }
  }

  get width() {
    let w = 0.0;
    if (defined(this.scrollContainer)) {
      w = this.scrollContainer.clientWidth;
    }
    return w;
  }

  get height() {
    let h = 0.0;
    if (defined(this.scrollContainer)) {
      h = this.scrollContainer.clientHeight;
    }
    return h;
  }

  componentWillUnmount() {
    this.setScrollContainer(null);
  }

  setScrollContainer(elem) {
    if (defined(this.scrollContainer)) {
      Ps.destroy(this.scrollContainer);

      window.removeEventListener('resize', this._windowResize);
    }

    this.scrollContainer = elem;

    if (defined(this.scrollContainer)) {
      Ps.initialize(this.scrollContainer, {
        suppressScrollX: !this.props.horizontalScroll,
        suppressScrollY: !this.props.verticalScroll,
      });

      window.addEventListener('resize', this._windowResize);
    }
  }

  windowResize() {
    Ps.update(this.scrollContainer);
  }

  render() {
    return (
      <div
        className="PerfectScrollbarContainer"
        ref={elem => this.setScrollContainer(elem)}
      >
        {this.props.children}
      </div>
    );
  }
}

PerfectScrollbarContainer.propTypes = {
  horizontalScroll: PropTypes.bool,
  verticalScroll: PropTypes.bool,
};

PerfectScrollbarContainer.defaultProps = {
  horizontalScroll: true,
  verticalScroll: true,
};

export default PerfectScrollbarContainer;



// WEBPACK FOOTER //
// ./src/components/PerfectScrollbarContainer.js